<!-- 协诊管理 -->
<template>
    <div class="app-container">
        <el-container class="container" direction="vertical">
            <el-row>
                <el-row>
                    <div style="font-size: 32;font-weight: bolder;">协诊管理</div>
                </el-row>
                <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />
            </el-row>

            <el-row style="margin-top: 30px;">
                <el-tabs type="border-card" @tab-click="clickTab">
                    <el-tab-pane label="糖尿病协诊记录">
                        <component :is="currentView1" :pInfo="pInfo" v-if="update1"></component>
                    </el-tab-pane>
                    <el-tab-pane label="高血压协诊记录">
                        <component :is="currentView2" :pInfo="pInfo" v-if="update2"></component>
                    </el-tab-pane>
                </el-tabs>
            </el-row>
        </el-container>
    </div>
</template>

<script>
import bloodGlucoseRecord from "./cooperativeDiagnosis/bloodGlucoseRecord.vue";
import bloodPressureRecord from "./cooperativeDiagnosis/bloodPressureRecord";

export default {
    components: { bloodGlucoseRecord, bloodPressureRecord },
    props: {
        pInfo: null
    },
    data() {
        return {
            currentView1: "bloodGlucoseRecord",
            currentView2: "bloodPressureRecord",
            update1: true,
            update2: false,
        };
    },
    methods: {
        clickTab(targetName) {
            console.log(targetName);
            if (targetName.label == "糖尿病协诊记录") {
                this.update1 = true;
                this.update2 = false;
            } else if (targetName.label == "高血压协诊记录") {
                this.update1 = false;
                this.update2 = true;
            }
        }
    }
};
</script>

<style></style>